









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
  computed: {},
})
export default class Card extends Vue {
  @Prop({ type: String }) title!: string;
  @Prop({ type: String }) image!: string;
  @Prop({ type: String }) url!: string;
}
